import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useStorage } from '@vueuse/core'

/**
 * Organization store used to track the creating of orgs
 * @typedef {function} twoFactorVerificationStore
 * @property {Object} state - twoFactorVerificationStore state
 * @property {string|null} state.email - Email
 * @property {string|null} state.password - Password
 * @property {string|null} state.tfa_token - Password
 */

export const useTwoFactorVerificationStore = defineStore('twoFactorVerificationStore', {
	state: () => ({
		email: null,
		password: null,
		tfa_token: useStorage('tfa_token', ref(null)),//local storage needed to trust device (not yet implemented)
	}),
	getters: {
		/**
		 * Masks email with *
		 * @returns {string}
		 */
		maskedEmail()
		{
			return this.email && this.email.replace(/^(.)(.*)(.@.*)$/,
				(_, a, b, c) => a + b.replace(/./g, '*') + c
			)
		},
		/**
		 * Returns the user's stored tfa_token
		 * @returns {null|string}
		 */
		tfaToken()
		{
			return this.tfa_token;
		}
	},
	actions: {
		/**
		 * Set email, password and token
		 * @param email
		 * @param password
		 * @param tfa_token
		 */
		setVerificationToken(email, password, tfa_token)
		{
			this.email = email
			this.password = password
			this.tfa_token = tfa_token
		},

		/**
		 * Clear token info on logout.
		 * @param email
		 * @param password
		 * @param tfa_token
		 */
		clearVerificationToken()
		{
			this.email = null
			this.password = null

			//Skip this if trust device added
			this.tfa_token = null
		},

		/**
		 * Clears the verification token
		 */
		logout()
		{
			this.clearVerificationToken()
		}
	}
})
